import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as StepLabels from "../../constants/StepLabels";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPen} from "@fortawesome/pro-light-svg-icons/faPen";
import {getCartSummary} from "../../selectors/Cart";
import SummaryArticleListing from "../../components/summary/SummaryArticleListing";
import SummaryTotalListing from "../../components/summary/SummaryTotalListing";
import StepControlButton, {CONTROL_PREV} from "../../components/navigation/StepControlButton";
import {copyValueFromElement, queryCartRecommend} from "../../actions/Recommend";
import {forceValidationOnSteps, selectStep} from "../../actions/StepControl";
import {getRecommendForm} from "../../selectors/Forms";
import HintWrapper from "../../components/HintWrapper";
import MigrationHintBox from "../../components/MigrationHintBox";
import {queryPreUpgradeCheck} from "../../actions/Accounts";

function mapStateToProps(state) {

    const recommendForm = getRecommendForm(state);

    return {
        ipChanges: state.productSelection.ipChanges,
        forcedValidationSteps: state.ui.forcedValidationSteps,
        cartSummary: getCartSummary(state),
        isFetching: state.cart.isFetching,
        orderComplete: state.appState.orderComplete,
        recommendFormValid: recommendForm && ((recommendForm.syncErrors && recommendForm.syncErrors.length === 0) || !recommendForm.syncErrors),
        presetId: state.outsourcing.presetId,
        presetUrl: state.outsourcing.url,
        presetPin: state.outsourcing.pin,
        presetExpireDate: state.outsourcing.expireDate,
        isCopied: state.outsourcing.isCopied
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        preUpgradeCheck: () => {
            dispatch(queryPreUpgradeCheck())
        },
        doRecommend: () => {
            dispatch(queryCartRecommend())
        },
        selectStep: (step) => {
            dispatch(selectStep(step))
        },
        forceValidation: () => {
            dispatch(forceValidationOnSteps([ownProps.stepLabel]))
        }
    };
}

class OutsourcingRecommendStep extends Component {

    constructor(props) {
        super(props);
        this.state = {
            urlCopied: false,
            pinCopied: false
        }
    }

    handleCopyPinHover() {
        this.setState({
            pinCopied: false
        });
    }

    handleCopyPinClick() {
        copyValueFromElement(document.getElementById("copy-pin-input"));
        this.setState({
            pinCopied: true
        });
    }

    handleCopyUrlHover() {
        this.setState({
            urlCopied: false
        });
    }

    handleCopyUrlClick() {
        copyValueFromElement(document.getElementById("copy-url-input"));
        this.setState({
            urlCopied: true
        });
    }

    componentDidMount() {
        this.props.preUpgradeCheck();
        this.props.doRecommend();
    }

    render() {

        const {cartSummary} = this.props;

        let validationError = null;

        const showError = !this.props.recommendFormValid && this.props.forcedValidationSteps.includes(StepLabels.OUTSOURCING_RECOMMEND)

        let urlInputValue = false;

        if (this.props.presetId) {
            urlInputValue = `https://bestellung.mittwald.de/v3/?preset=${this.props.presetId}`;
        } else if (this.props.presetUrl) {
            urlInputValue = this.props.presetUrl;
        }

        if (showError) {
            validationError = <HintWrapper
                content={"Bitte überprüfe deine Eingaben!"}
                theme="error"
            />
        }
        return (
            <div className="step-display__page summary-step recommend-step">

                <h1>Bestellübersicht</h1>

                {this.props.ipChanges ? <MigrationHintBox/> : null}

                <div className="summary-step__overview-head">
                    <h2>Dein Tarif</h2>
                    <a onClick={(e) => {
                        this.props.selectStep(StepLabels.OUTSOURCING_CONFIG)
                    }}><FontAwesomeIcon icon={faPen}/></a>
                </div>

                <SummaryArticleListing cartSummary={cartSummary}/>

                <SummaryTotalListing cartSummary={cartSummary}/>

                <div className="summary-step__overview-head">
                    <h2>Empfehlung versenden</h2>
                    <p>Zur Ausgliederung des Projekts muss der neue Vertragspartner die Bestellung mit seinen Kundendaten durchführen und bestätigen.</p>
                    <p>Schicke diesem den folgenden Link und den PIN-Code.</p>
                    <p>Sobald der neue Vertragspartner die Ausgliederung damit abschließt, wird das Projekt automatisch zu ihm übertragen.</p>
                </div>

                <div className={"summary-step__recommend"}>
                    <div className="copy-hint">
                        Bestell-Link für den neuen Vertragspartner
                    </div>
                    <div className="copy-display">
                        <input id="copy-url-input" autoCorrect="off" spellCheck="false"
                               onChange={(e) => {
                               }} type="text" value={urlInputValue}/>
                        {this.state.urlCopied ?
                            <a
                                onClick={() => {
                                    this.handleCopyUrlClick();
                                }} className="copied"
                                onMouseEnter={() => {
                                    this.handleCopyUrlHover();
                                }}
                            >
                                Kopiert!
                            </a> : (this.props.presetId || this.props.presetUrl) ?
                                <a
                                    onClick={() => {
                                        this.handleCopyUrlClick();
                                    }}
                                >Kopieren
                                </a> : <a>Kopieren</a>}
                    </div>
                    <div className="copy-hint">
                        Bestell-PIN für den neuen Vertragspartner
                    </div>
                    <div className="copy-display">
                        <input id="copy-pin-input" autoCorrect="off" spellCheck="false"
                               onChange={(e) => {
                               }} type="text" value={this.props.presetPin}/>
                        {this.state.pinCopied ?
                            <a
                                onClick={() => {
                                    this.handleCopyPinClick();
                                }} className="copied"
                                onMouseEnter={() => {
                                    this.handleCopyPinHover();
                                }}
                            >
                                Kopiert!
                            </a> : (this.props.presetPin || this.props.presetPin) ?
                                <a
                                    onClick={() => {
                                        this.handleCopyPinClick();
                                    }}
                                >Kopieren
                                </a> : <a>Kopieren</a>}
                    </div>
                    <div className={"copy-expiration"}>
                        Der Link und die PIN sind gültig bis zum {this.props.presetExpireDate}.
                    </div>
                </div>

                {validationError}

                <div className="step-display__page__control">

                    {this.props.prevLabel !== "" ? <StepControlButton type={CONTROL_PREV} label={this.props.prevLabel}
                                                                      onClick={this.props.onButtonPrevClick}/> : null}
                </div>

            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OutsourcingRecommendStep);


/** WEBPACK FOOTER **
 ** ./src/containers/outsourcing/OutsourcingRecommendStep.js
 **/